import { render, staticRenderFns } from "./XUserAccountLog.vue?vue&type=template&id=68849680&scoped=true"
import script from "./XUserAccountLog.vue?vue&type=script&lang=js"
export * from "./XUserAccountLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68849680",
  null
  
)

export default component.exports